import { createSelector } from 'reselect';
import { KEY } from './';
import { GlobalState } from 'store/types';

const getMediaState = (state: GlobalState) => state[KEY];

const selectAction = createSelector(getMediaState, (state) => state.action);

const selectEventImages = createSelector(getMediaState, (state) => state.event);

const selectVenueImages = createSelector(getMediaState, (state) => state.venue);

const selectGenreImages = createSelector(getMediaState, (state) => state.genre);

const selectAttractImages = createSelector(getMediaState, (state) => state.attractImage);

const selectAttractVideo = createSelector(getMediaState, (state) => state.attractVideo);

const selectInactiveImage = createSelector(getMediaState, (state) => state.inactiveImage);

const selectSplashImage = createSelector(getMediaState, (state) => state.splashImage);

const selectBackgroundImage = createSelector(getMediaState, (state) => state.backgroundImage);

const selectLogoImage = createSelector(getMediaState, (state) => state.logoImage);

const selectPromoCodeImages = createSelector(getMediaState, (state) => state.promoCodeImage || []);

export const selectors = {
  selectAction,
  selectEventImages,
  selectVenueImages,
  selectGenreImages,
  selectAttractImages,
  selectAttractVideo,
  selectInactiveImage,
  selectSplashImage,
  selectBackgroundImage,
  selectLogoImage,
  selectPromoCodeImages
};
